module.exports = __webpack_public_path__ + "static/3d679abc452d401e4518714e9dd6e4fdbd68369cb88d2a1b53e8d8ada78d5313-42a63587bd04544767017aec7358b84e.png";